'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$002dTwo$002dFactor$002dAuth$002dId$0024 from "./presto.types$-Two-Factor-Auth-Id$.js";
var $p;
/** @constructor */
function $c_Lpresto_TwoFactorAuthView$$anon$1(outer) {
  this.bB9 = null;
  this.bB7 = null;
  this.bB8 = false;
  this.bB5 = null;
  this.bB6 = false;
  this.bBa = false;
  this.bBb = false;
  if ((outer === null)) {
    throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_NullPointerException__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_NullPointerException());
  }
  this.bB9 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
}
export { $c_Lpresto_TwoFactorAuthView$$anon$1 as $c_Lpresto_TwoFactorAuthView$$anon$1 };
$p = $c_Lpresto_TwoFactorAuthView$$anon$1.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_TwoFactorAuthView$$anon$1;
/** @constructor */
function $h_Lpresto_TwoFactorAuthView$$anon$1() {
}
export { $h_Lpresto_TwoFactorAuthView$$anon$1 as $h_Lpresto_TwoFactorAuthView$$anon$1 };
$h_Lpresto_TwoFactorAuthView$$anon$1.prototype = $p;
$p.a1 = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a);
});
$p.af = (function() {
  return this.bB9;
});
$p.t = (function() {
  if ((!this.bB8)) {
    this.bB7 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("id", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$());
    this.bB8 = true;
  }
  return this.bB7;
});
$p.ag = (function() {
  if ((!this.bB6)) {
    this.bB5 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dTwo$002dFactor$002dAuth$002dId$0024.$m_Lpresto_types$TwoFactorAuthId$().vn(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$());
    this.bB6 = true;
  }
  return this.bB5;
});
$p.v = (function() {
  if ((!this.bBb)) {
    this.bBa = false;
    this.bBb = true;
  }
  return this.bBa;
});
$p.ae = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredEncoder__encodeProduct__O__Lio_circe_JsonObject(this, a);
});
var $d_Lpresto_TwoFactorAuthView$$anon$1 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_TwoFactorAuthView$$anon$1, "presto.TwoFactorAuthView$$anon$1", ({
  Sl: 1,
  a: 1,
  l: 1,
  n: 1,
  o: 1,
  p: 1,
  d: 1
}));
export { $d_Lpresto_TwoFactorAuthView$$anon$1 as $d_Lpresto_TwoFactorAuthView$$anon$1 };
//# sourceMappingURL=presto.-Two-Factor-Auth-View$$anon$1.js.map
